module.exports = __webpack_public_path__ + "static/img/jjcFirst.1d8957e2.png";